import { useState } from 'react'

import { Box, Fade } from '@mui/material'
import { styled } from '@mui/system'

import { basemaps } from '../../../common/layers'
import { BasemapButton } from '../../../common/map'
import useIsMobile from '../../../common/hooks/useIsMobile'

const Container = styled(Box)(({ theme, drawerWidth, isMobile }) => ({
  position: 'absolute',
  left: isMobile ? 0 : drawerWidth,
  bottom: theme.spacing(1),
  zIndex: 1000,
}))

const OptionsContainer = styled(Box)(() => ({
  float: 'left',
}))

const BasemapControl = ({ basemap, drawerWidth, setBasemap }) => {
  const isMobile = useIsMobile()

  const [showOptions, setShowOptions] = useState(false)

  return (
    <Container
      isMobile={isMobile}
      onMouseEnter={() => setShowOptions(true)}
      onMouseLeave={() => setShowOptions(false)}
      onTouchEnd={() => setShowOptions(!showOptions)}
      drawerWidth={drawerWidth}
    >
      <BasemapButton
        displayName={basemaps[basemap].displayName}
        iconUrl={basemaps[basemap].iconUrl}
        name={basemap}
      />
      <Fade in={showOptions} timeout={500} unmountOnExit={true}>
        <OptionsContainer>
          {Object.entries(basemaps)
            .filter(([key, _]) => key !== basemap)
            .map(([key, val]) => (
              <BasemapButton
                key={key}
                displayName={val.displayName}
                iconUrl={val.iconUrl}
                name={key}
                onClick={() => setBasemap(key)}
              />
            ))}
        </OptionsContainer>
      </Fade>
    </Container>
  )
}

export default BasemapControl
